/*eslint-disable*/

import React, { useEffect } from "react";
import "../css/main.css";
import Map from "../components/Map";

import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import $ from "jquery";
import "fullpage.js/vendors/scrolloverflow";
import "fullpage.js";
import "fullpage.js/dist/jquery.fullpage.min.css";

import "react-slideshow-image/dist/styles.css";
import { Fade } from "react-slideshow-image";
import slide01 from "../images/slide01.png";
import slide02 from "../images/slide02.png";
import slide03 from "../images/slide03.png";

import mainObj from "../images/mainObj.png";
import Dobj from "../images/Dobj.svg";

import arrow from "../images/arrow.png";
import circleArrow1 from "../images/circleArrow1.png";
import circleArrow2 from "../images/circleArrow2.png";
import circleArrow3 from "../images/circleArrow3.png";
import mainFlogo from "../images/mainfooter-logo.png";

function Fullpage() {
  useEffect(() => {
    if ($("html").hasClass("fp-enabled")) {
      $.fn.fullpage.destroy("all");
    }
    $("#fullpage").fullpage({
      scrollBar: false,
      css: true,
      scrollingSpeed: 700,
      navigation: true,
      loopBottom: true,
    });
  });

  let history = useHistory();

  return (
    <div id="fullpage">
      <div className="section fp-scrollable first">
        {/* <FadeExample /> */}
        {/* <div className="mainBg"></div> */}
        <img src={mainObj} alt="" className="mainObj" />
        <h2>
          Data Infrastructure, <br /> <br /> 사람·도시·산업·경제 간 <br />{" "}
          데이터를 연결하여 가치를 창출합니다
        </h2>
      </div>

      <div className="section second">
        <div>
          <h2>
            <span>&nbsp;새로운 가치를 창조하는 기술</span>
            DREAM IMAGINATION
          </h2>

          <div className="contents">
            <div className="vision">
              <p>DI Solution</p>
              <div className="bar"></div>
              <p>
                우리는 <br />
                데이터를 통한 <br />
                새로운 가치를 창조하고 <br />
                시장을 선도합니다.
              </p>
              <a
                onClick={() => {
                  window.location.href = "/company/1";
                }}
              >
                자세히보기
                <img src={arrow} />
              </a>
            </div>
            <div className="value">
              <p>VISION&VALUE</p>
              <div className="bar"></div>
              <p>
                Creative <br />
                Innovation <br />
                Partnership <br />
              </p>
              <a
                onClick={() => {
                  window.location.href = "/company/2";
                }}
              >
                자세히보기
                <img src={arrow} />
              </a>
            </div>
            <div className="mission">
              <p>HISTORY</p>
              <div className="bar"></div>
              <p>
                우리는 <br />
                데이터를 통한 <br />
                새로운 가치를 창조하고 <br />
                시장을 선도합니다.
              </p>
              <a
                onClick={() => {
                  window.location.href = "/company/3";
                }}
              >
                자세히보기
                <img src={arrow} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="section third">
        <div>
          <h2>
            <span>&nbsp;시장을 선도하는 기술</span>
            OUR SOLUTION
          </h2>

          <div className="contents">
            <div
              className="deeplearning"
              onClick={() => {
                window.location.href = "/solution/1";
              }}
            >
              <div>
                <p>
                  딥러닝솔루션
                  <span>Deep learning solution</span>
                </p>
                <a>
                  <img src={circleArrow1} />
                </a>
              </div>
              <div>
                <p>GPU 기반 VDI 클라우드 시스템, 딥러닝용 클라우드</p>
              </div>
            </div>
            <div
              className="bigdata"
              onClick={() => {
                window.location.href = "/solution/2";
              }}
            >
              <div>
                <p>
                  빅데이터솔루션
                  <span>Big data solution</span>
                </p>
                <a>
                  <img src={circleArrow2} />
                </a>
              </div>
              <div>
                <p>
                  사람, 차량 등의 딥러닝 기반 실시간 영상 분석 및 상황인지형
                  모니터링
                </p>
              </div>
            </div>
            <div
              className="cloud"
              onClick={() => {
                window.location.href = "/solution/3";
              }}
            >
              <div>
                <p>
                  클라우드 구축
                  <span>Cloud</span>
                </p>
                <a>
                  <img src={circleArrow3} />
                </a>
              </div>
              <div>
                <p>
                  GPU 기반 VDI 클라우드 시스템, 딥러닝용 클라우드 시스템 등 특수
                  목적 클라우드 환경 구축
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section forth">
        <div>
          <h2>
            <span>&nbsp;멋있는 멘트</span>
            OUR BUSINESS
          </h2>

          <div className="contents">
            <div
              className="m2m"
              onClick={() => {
                window.location.href = "/business/1";
              }}
            >
              <div className="bg"></div>
              <div className="linkBox">
                <p>
                  Business
                  <br />
                  Information
                </p>
                <span>
                  자세히보기
                  <img src={arrow} />
                </span>
              </div>
            </div>
            <div
              className="installEx"
              onClick={() => {
                window.location.href = "/business/2";
              }}
            >
              <div className="bg"></div>
              <div className="linkBox">
                <p>
                  Installation
                  <br />
                  Example
                </p>
                <span>
                  자세히보기
                  <img src={arrow} />
                </span>
              </div>
            </div>
            <div
              className="product"
              onClick={() => {
                window.location.href = "/business/3";
              }}
            >
              <div className="bg"></div>
              <div className="linkBox">
                <p>
                  Product
                  <br />
                  Information
                </p>
                <span>
                  자세히보기
                  <img src={arrow} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section fifth">
        <div className="contents">
          <div className="footer-left">
            <h2>CONTACT</h2>
            <div className="circle1"></div>
            <div className="footerCon">
              <h3>(주)디아이솔루션</h3>
              <img src={mainFlogo} alt="logo" />
              <div>
                <p>
                  대표이사<span>남태우</span>
                </p>
                <p>
                  소재지
                  <span>부산광역시 동래구 온천장로 109 불이빌딩 3층</span>
                </p>
                <p>
                  Tel.<span>051-717-2503</span>
                </p>
                <p>
                  Fax.<span>070-8282-0624</span>
                </p>
              </div>
              <p>Copyright © 2022 DI SOLUTION All Rights Reserved.</p>
            </div>
          </div>
          <div className="footer-right">
            <h2>LOCATION</h2>
            <div className="circle1"></div>
            <Map />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Fullpage;

const FadeExample = () => {
  const fadeImages = [slide01, slide02, slide03];

  const fadeProperties = {
    pauseOnHover: false,
  };

  return (
    <div>
      <div className="slide-container">
        <Fade {...fadeProperties}>
          <div className="each-fade">
            <div>
              <img src={fadeImages[0]} />
            </div>
          </div>
          <div className="each-fade">
            <div>
              <img src={fadeImages[1]} />
            </div>
          </div>
          <div className="each-fade">
            <div>
              <img src={fadeImages[2]} />
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};
